import * as React from "react"
import * as _ from "lodash"
import IDiagnosticSuggestions from "../../models/IDiagnosticSuggestions";
import TextInput from "../TextInput";
import DurationComponent from "../DurationComponent";
import IStaticDataValue from "../../../../common/models/IStaticDataValue";
import {AppConstants, AppPlaceholders} from "../../utils/AppConstants";
import ModelFactory from "../../models/ModelFactory";
import IPatientWorkoutPreference from "../../models/patients/IPatientWorkoutPreference";
import ToggleButtonList from "../ToggleButtonList";
import TypeAhead, { TypeAheadElement, TypeAheadResults} from "../TypeAhead";
import {IWorkoutTagCatalogueResponse} from "../../models/maverick/IWorkoutTagCatalogueResponse";
import AppUtils from "../../utils/AppUtils";

/*
 * created by aditya on 25/07/18
 */

export interface WorkoutPreferenceItemEditorProps {
    item: IPatientWorkoutPreference;
    onDataChange: (update: IPatientWorkoutPreference) => any,
    fetchStaticActivities?: (input: string) => Promise<IDiagnosticSuggestions[]>,
    consultationType: string,
    fetchFitnessActivities?: (input: string) => Promise<any>;
}

export interface WorkoutPreferenceItemEditorState {
    validate: boolean
}

class WorkoutPreferenceItemEditor extends React.Component<WorkoutPreferenceItemEditorProps, WorkoutPreferenceItemEditorState> {
    private workoutPreferenceItemDOM: any;
    constructor(props: WorkoutPreferenceItemEditorProps) {
        super(props);
        this.state = {
            validate: false
        }
    }
    onFitnessActivityTypeAheadChange = (input: string) => {
        let typeAheadResults: TypeAheadResults;
        let typeAheadArray: TypeAheadElement[] = [];
        let workoutType = { value: input, comment: "" };
        let updatedItem = { ...this.props.item, type: workoutType };
        this.props.onDataChange(updatedItem);
        return this.props.fetchFitnessActivities(input).then((results: IWorkoutTagCatalogueResponse[]): Promise<TypeAheadResults> => {
            if (results.length) {
                _.map(results, (workoutActivity) => {
                    let typeAheadElement = {
                        value: workoutActivity.internalValue,
                        label: workoutActivity.displayValue,
                        others: {
                            sourceKind: workoutActivity.sourceKind
                        }
                    }
                    typeAheadArray.push(typeAheadElement);
                })
                typeAheadResults = {options: typeAheadArray, completed: true};
                return Promise.resolve(typeAheadResults);
            } else {
                return Promise.resolve({options: [], completed: false});
            }
        }).catch((error: any) => {
            throw error;
        });
    };

    onFitnessActivityTypeAheadSelect = (elem: TypeAheadElement) => {
        let workoutType = { value: elem.label, comment: "" };
        let updatedItem = { ...this.props.item, type: workoutType };
        this.props.onDataChange(updatedItem);
    };

    onWorkoutTypeChange = (evt: any) => {
        let updatedPreference = { ...this.props.item, name: evt.target.value };
        this.props.onDataChange(updatedPreference);
    }
    onTimeOfDayChange = (selectedItems: string[]) => {
        let updatedPreference = { ...this.props.item, timesOfDay: selectedItems }
        this.props.onDataChange(updatedPreference);
    }
    onFrequencyChange = (elem: TypeAheadElement) => {
        let frequency = { value: elem.others.value };
        let updatedItem = { ...this.props.item, frequency };
        this.props.onDataChange(updatedItem);
    }
    onDurationChange = (evt: any) => {
        let durationInSeconds = AppUtils.isDefined(evt.target.value) && !isNaN(parseInt(evt.target.value))
            ? evt.target.value.replace(/[^\d.-]/g, "") * 60
            : null;
        let updatedItem = { ...this.props.item, duration: durationInSeconds };
        this.props.onDataChange(updatedItem);
    }
    onCommentsChange = (evt: any) => {
        let comments = evt.target.value
        let updatedItem = { ...this.props.item, comments};
        this.props.onDataChange(updatedItem);
    }
    generateWorkoutSlotListItems = () => {
        let listItems: IStaticDataValue[] = [];
        _.map(AppConstants.TIME_OF_DAY, (slot: string) => {
            let item = ModelFactory.createNewStaticItem();
            item.displayValue = slot;
            item.internalValue = slot.toLowerCase();
            listItems.push(item);
        })
        return listItems;
    }
    generateFrequencyListItems() {
        let frequencyList: IStaticDataValue[] = [];
        _.map(AppConstants.FrequencyUnit, (type, key) => {
            let medicineFrequency = ModelFactory.createNewStaticItem();
            medicineFrequency.internalValue = key;
            medicineFrequency.displayValue = type;
            frequencyList.push(medicineFrequency);
        })
        return frequencyList;
    }
    render() {
        let workoutType = !_.isEmpty(this.props.item.type) && !_.isEmpty(this.props.item.type.value)  ? this.props.item.type.value : "";
        let selectedSlots = !_.isEmpty(this.props.item.timesOfDay) ? this.props.item.timesOfDay : [];
        let frequencyCount = !_.isEmpty(this.props.item.frequency) && !_.isEmpty(this.props.item.frequency.value) ? this.props.item.frequency.value.count : null;
        let frequencyUnit = !_.isEmpty(this.props.item.frequency) && !_.isEmpty(this.props.item.frequency.value)  ? this.props.item.frequency.value.unit : null;
        let duration = this.props.item.duration !== undefined && this.props.item.duration !== null ? this.props.item.duration / 60 : null;
        let comments = AppUtils.isDefined(this.props.item.comments) ? this.props.item.comments : null;
        return (
            <div className="workout-preference-item-editor" ref={(referralItemDOM) => this.workoutPreferenceItemDOM = referralItemDOM}>
                <div className={"workout-preference-item-type"}>
                    <TypeAhead widgetName={"WorkoutPreferenceItem"} name={"fitness-activity-name"} value={workoutType || ""} placeholder={AppPlaceholders.FITNESS_PLAN_ACTIVITY} onTypeAheadChange={this.onFitnessActivityTypeAheadChange} onTypeAheadSelect={this.onFitnessActivityTypeAheadSelect}/>
                    {/*<TextInput name={"workout-preference-type"} placeholder={AppPlaceholders.WORKOUT_PREFERENCES_ACTIVITY} onChange={this.onWorkoutTypeChange} value={workoutType}/>*/}
                </div>
                <div className={"workout-preference-item-time"}>
                    <ToggleButtonList listItems={this.generateWorkoutSlotListItems()} selectedItems={selectedSlots} onSelectionChange={this.onTimeOfDayChange}/>
                </div>
                <div className={"workout-preference-item-frequency"}>
                    <DurationComponent placeholder={AppPlaceholders.WORKOUT_PREFERENCES_FREQUENCY} unit={frequencyUnit} count={frequencyCount} dropdownItems={this.generateFrequencyListItems()}
                                       rootClass={"workout-preference-frequency"} onDurationChange={this.onFrequencyChange} isFrequency={true} />
                </div>
                <div className={"workout-preference-item-duration"}>
                    <TextInput name={"workout-preference-duration"} onChange={this.onDurationChange} value={duration}/>
                    <span className={"unit-label"}>mins</span>
                </div>
                <div className={"workout-preference-item-comments"}>
                    <TextInput name={"workout-preference-comments"} onChange={this.onCommentsChange} value={comments}/>
                </div>
            </div>
        )
    }
}

export default WorkoutPreferenceItemEditor;